import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

/**
 * @returns {boolean}
 */
export const useEnablePickPackStationV2Features = () => useFeatureFlag(FeatureFlagDeclarations.enablePickPackStationV2Features);
